import { apiPaths, apiActions } from "./db"

export const enumRoles = { ADMIN: 1, MANAGER: 2, FINANCE: 3, SUPPORT: 4, ADVERTISER: 5, BAN: 99 }

const enumPermissionActions = { ...apiActions }
const EPA = enumPermissionActions

export const enumPermissionModules = { ...apiPaths }
const EPM = enumPermissionModules

export const enumPermissions = {
  ADMIN_COUNTRY_LIST: `${EPM.ADMIN_COUNTRY}/${EPA.LIST}`,
  // Admin - Permissions
  ADMIN_PERMISSIONS_GET: `${EPM.ADMIN_PERMISSIONS}/${EPA.GET}`,
  ADMIN_PERMISSIONS_UPDATE: `${EPM.ADMIN_PERMISSIONS}/${EPA.UPDATE}`,
  // Admin - Users
  ADMIN_USERS_LIST: `${EPM.ADMIN_USERS}/${EPA.LIST}`,
  ADMIN_USERS_GET: `${EPM.ADMIN_USERS}/${EPA.GET}`,
  ADMIN_USERS_CREATE: `${EPM.ADMIN_USERS}/${EPA.CREATE}`,
  ADMIN_USERS_UPDATE: `${EPM.ADMIN_USERS}/${EPA.UPDATE}`,
  ADMIN_USERS_DELETE: `${EPM.ADMIN_USERS}/${EPA.DELETE}`,
  ADMIN_USERS_VALIDATE: `${EPM.ADMIN_USERS}/${EPA.VALIDATE}`,
  //Admin - Users Balance
  ADMIN_USERS_BALANCE_LIST: `${EPM.ADMIN_USERS_BALANCE}/${EPA.LIST}`,
  //Admin Logs - Queue email
  ADMIN_LOGS_QUEUE_EMAIL: `${EPM.ADMIN_LOGS}/${EPA.QUEUE_EMAIL}`,
  // Admin - Campaigns
  ADMIN_CAMPAIGNS_LIST: `${EPM.ADMIN_CAMPAIGNS}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_GET: `${EPM.ADMIN_CAMPAIGNS}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_CREATE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.CREATE}`,
  ADMIN_CAMPAIGNS_UPDATE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_DELETE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.DELETE}`,
  ADMIN_CAMPAIGNS_ARCHIVE: `${EPM.ADMIN_CAMPAIGNS}/${EPA.ARCHIVE}`,
  ADMIN_CAMPAIGNS_COPY: `${EPM.ADMIN_CAMPAIGNS}/${EPA.COPY}`,
  //Admin - Bids
  ADMIN_BIDS_LIST: `${EPM.ADMIN_BIDS}/${EPA.LIST}`,
  ADMIN_BIDS_UPDATE: `${EPM.ADMIN_BIDS}/${EPA.UPDATE}`,
  ADMIN_BIDS_CREATE: `${EPM.ADMIN_BIDS}/${EPA.CREATE}`,
  ADMIN_BIDS_GET: `${EPM.ADMIN_BIDS}/${EPA.GET}`,
  ADMIN_BIDS_DELETE: `${EPM.ADMIN_BIDS}/${EPA.DELETE}`,
  // Admin - fast login
  ADMIN_FAST_LOGIN_CREATE: `${EPM.ADMIN_FAST_LOGIN}/${EPA.CREATE}`,
  ADMIN_FAST_LOGIN_CHECK: `${EPM.ADMIN_FAST_LOGIN}/${EPA.CHECK}`,
  //ADMIN - Campaigns Single
  ADMIN_CAMPAIGNS_AUDIENCE_GET: `${EPM.ADMIN_CAMPAIGNS_AUDIENCE}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_AUDIENCE_UPDATE: `${EPM.ADMIN_CAMPAIGNS_AUDIENCE}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_LIMITS_CREATE: `${EPM.ADMIN_CAMPAIGNS_LIMITS}/${EPA.CREATE}`,
  ADMIN_CAMPAIGNS_LIMITS_LIST: `${EPM.ADMIN_CAMPAIGNS_LIMITS}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_LIMITS_DELETE: `${EPM.ADMIN_CAMPAIGNS_LIMITS}/${EPA.DELETE}`,
  ADMIN_CAMPAIGNS_CREATIVES_LIST: `${EPM.ADMIN_CAMPAIGNS_CREATIVES}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_CREATIVES_CREATE: `${EPM.ADMIN_CAMPAIGNS_CREATIVES}/${EPA.CREATE}`,
  ADMIN_CAMPAIGNS_CREATIVES_GET: `${EPM.ADMIN_CAMPAIGNS_CREATIVES}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_CREATIVES_DELETE: `${EPM.ADMIN_CAMPAIGNS_CREATIVES}/${EPA.DELETE}`,
  ADMIN_CAMPAIGNS_CREATIVES_UPDATE: `${EPM.ADMIN_CAMPAIGNS_CREATIVES}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_CREATIVES_DUPLICATE: `${EPM.ADMIN_CAMPAIGNS_CREATIVES}/${EPA.DUPLICATE}`,
  ADMIN_CAMPAIGNS_PRICING_UPDATE: `${EPM.ADMIN_CAMPAIGNS_PRICING}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_PRICING_GET: `${EPM.ADMIN_CAMPAIGNS_PRICING}/${EPA.GET}`,
  ADMIN_CAMPAIGNS_PRICING_DELETE: `${EPM.ADMIN_CAMPAIGNS_PRICING}/${EPA.DELETE}`,
  ADMIN_CAMPAIGNS_GROUPS_LIST: `${EPM.ADMIN_CAMPAIGNS_GROUPS}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_GROUPS_UPDATE: `${EPM.ADMIN_CAMPAIGNS_GROUPS}/${EPA.UPDATE}`,
  ADMIN_CAMPAIGNS_BIDS_LIST: `${EPM.ADMIN_CAMPAIGNS_BIDS}/${EPA.LIST}`,
  ADMIN_CAMPAIGNS_BIDS_UPDATE: `${EPM.ADMIN_CAMPAIGNS_BIDS}/${EPA.UPDATE}`,
  // Admin - Groups
  ADMIN_GROUPS_LIST: `${EPM.ADMIN_GROUPS}/${EPA.LIST}`,
  ADMIN_GROUPS_CREATE: `${EPM.ADMIN_GROUPS}/${EPA.CREATE}`,
  ADMIN_GROUPS_DELETE: `${EPM.ADMIN_GROUPS}/${EPA.DELETE}`,
  ADMIN_GROUPS_UPDATE: `${EPM.ADMIN_GROUPS}/${EPA.UPDATE}`,
  ADMIN_GROUPS_GET: `${EPM.ADMIN_GROUPS}/${EPA.GET}`,
  //Admin - Unnaproved creatives
  ADMIN_UNAPPROVED_CREATIVES_LIST: `${EPM.ADMIN_UNAPPROVED_CREATIVES}/${EPA.LIST}`,
  ADMIN_UNAPPROVED_CREATIVES_APPROVED: `${EPM.ADMIN_UNAPPROVED_CREATIVES}/${EPA.APPROVED}`,
  ADMIN_UNAPPROVED_CREATIVES_REJECT: `${EPM.ADMIN_UNAPPROVED_CREATIVES}/${EPA.REJECT}`,
  ADMIN_UNAPPROVED_CREATIVES_TOTAL: `${EPM.ADMIN_UNAPPROVED_CREATIVES}/${EPA.TOTAL}`,
  //Admin - Unapproved Users
  ADMIN_UNAPPROVED_USERS_LIST: `${EPM.ADMIN_UNAPPROVED_USERS}/${EPA.LIST}`,
  ADMIN_UNAPPROVED_USERS_APPROVED: `${EPM.ADMIN_UNAPPROVED_USERS}/${EPA.APPROVED}`,
  ADMIN_UNAPPROVED_USERS_REJECT: `${EPM.ADMIN_UNAPPROVED_USERS}/${EPA.REJECT}`,
  ADMIN_UNAPPROVED_USERS_TOTAL: `${EPM.ADMIN_UNAPPROVED_USERS}/${EPA.TOTAL}`,
  ADMIN_UNAPPROVED_USERS_SET_MANAGER: `${EPM.ADMIN_UNAPPROVED_USERS}/${EPA.SET_MANAGER}`,
  //Admin - Dashboard
  ADMIN_DASHBOARD_SUM: `${EPM.ADMIN_DASHBOARD}/${EPA.SUM}`,
  ADMIN_DASHBOARD_CHART: `${EPM.ADMIN_DASHBOARD}/${EPA.CHART}`,
  //Admin - Stats
  ADMIN_STATS_REPORT: `${EPM.ADMIN_STATS}/${EPA.REPORT}`,
  ADMIN_STATS_BALANCE: `${EPM.ADMIN_STATS}/${EPA.BALANCE}`,
  // Admin - Topups
  ADMIN_TOPUPS_LIST: `${EPM.ADMIN_TOPUPS}/${EPA.LIST}`,
  ADMIN_TOPUPS_GET: `${EPM.ADMIN_TOPUPS}/${EPA.GET}`,
  ADMIN_TOPUPS_CREATE: `${EPM.ADMIN_TOPUPS}/${EPA.CREATE}`,
  ADMIN_TOPUPS_UPDATE: `${EPM.ADMIN_TOPUPS}/${EPA.UPDATE}`,
  ADMIN_TOPUPS_DELETE: `${EPM.ADMIN_TOPUPS}/${EPA.DELETE}`,
  // Admin - Login history
  ADMIN_LOGIN_HISTORY_LIST: `${EPM.ADMIN_LOGIN_HISTORY}/${EPA.LIST}`,
  // Admin - Profile
  ADMIN_PROFILE_GET: `${EPM.ADMIN_PROFILE}/${EPA.GET}`,
  ADMIN_PROFILE_UPDATE: `${EPM.ADMIN_PROFILE}/${EPA.UPDATE}`,
  //Admin - Recommended CPC
  ADMIN_RECOMMENDED_CPC_GET: `${EPM.ADMIN_RECOMMENDED_CPC}/${EPA.GET}`,
  ADMIN_RECOMMENDED_CPC_LIST: `${EPM.ADMIN_RECOMMENDED_CPC}/${EPA.LIST}`,
  ADMIN_RECOMMENDED_CPC_CREATE: `${EPM.ADMIN_RECOMMENDED_CPC}/${EPA.CREATE}`,
  ADMIN_RECOMMENDED_CPC_UPDATE: `${EPM.ADMIN_RECOMMENDED_CPC}/${EPA.UPDATE}`,
  ADMIN_RECOMMENDED_CPC_DELETE: `${EPM.ADMIN_RECOMMENDED_CPC}/${EPA.DELETE}`,
  //Admin - Overview
  ADMIN_OVERVIEW_COUNTRIES: `${EPM.ADMIN_OVERVIEW}/${EPA.COUNTRIES}`,

  // Admin - Change-log
  ADMIN_CHANGELOG_LIST: `${EPM.ADMIN_CHANGELOG}/${EPA.LIST}`,
  ADMIN_CHANGELOG_CREATE: `${EPM.ADMIN_CHANGELOG}/${EPA.CREATE}`,
  ADMIN_CHANGELOG_DELETE: `${EPM.ADMIN_CHANGELOG}/${EPA.DELETE}`,
  ADMIN_CHANGELOG_UPDATE: `${EPM.ADMIN_CHANGELOG}/${EPA.UPDATE}`,

  // Settings
  SETTINGS_GET: `${EPM.SETTINGS}/${EPA.GET}`,
  SETTINGS_UPDATE: `${EPM.SETTINGS}/${EPA.UPDATE}`,

}
const EP = enumPermissions

export const constructedPermissionTree = {
  [EPM.ADMIN_COUNTRY]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_COUNTRY_LIST]
  },
  [EPM.ADMIN_USERS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE, EPA.VALIDATE],
    modified: [EP.ADMIN_USERS_LIST, EP.ADMIN_USERS_GET, EP.ADMIN_USERS_CREATE, EP.ADMIN_USERS_UPDATE, EP.ADMIN_USERS_DELETE, EP.ADMIN_USERS_VALIDATE]
  },
  [EPM.ADMIN_PERMISSIONS]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_PERMISSIONS_GET, EP.ADMIN_PERMISSIONS_UPDATE]
  },
  [EPM.ADMIN_CAMPAIGNS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE, EPA.ARCHIVE, EPA.COPY],
    modified: [EP.ADMIN_CAMPAIGNS_LIST, EP.ADMIN_CAMPAIGNS_GET, EP.ADMIN_CAMPAIGNS_CREATE, EP.ADMIN_CAMPAIGNS_UPDATE, EP.ADMIN_CAMPAIGNS_DELETE, EP.ADMIN_CAMPAIGNS_ARCHIVE, EP.ADMIN_CAMPAIGNS_COPY]
  },
  [EPM.ADMIN_CAMPAIGNS_CREATIVES]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE, EPA.DUPLICATE],
    modified: [EP.ADMIN_CAMPAIGNS_CREATIVES_LIST, EP.ADMIN_CAMPAIGNS_CREATIVES_GET, EP.ADMIN_CAMPAIGNS_CREATIVES_CREATE, EP.ADMIN_CAMPAIGNS_CREATIVES_UPDATE, EP.ADMIN_CAMPAIGNS_CREATIVES_DELETE, EP.ADMIN_CAMPAIGNS_CREATIVES_DUPLICATE]
  },
  [EPM.ADMIN_CAMPAIGNS_GROUPS]: {
    original: [EPA.LIST, EPA.UPDATE],
    modified: [EP.ADMIN_CAMPAIGNS_GROUPS_LIST, EP.ADMIN_CAMPAIGNS_GROUPS_UPDATE]
  },
  [EPM.ADMIN_USERS_BALANCE]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_USERS_BALANCE_LIST]
  },
  [EPM.ADMIN_FAST_LOGIN]: {
    original: [EPA.CREATE, EPA.CHECK],
    modified: [EP.ADMIN_FAST_LOGIN_CREATE, EP.ADMIN_FAST_LOGIN_CHECK]
  },
  [EPM.ADMIN_LOGS]: {
    original: [EPA.QUEUE_EMAIL],
    modified: [EP.ADMIN_LOGS_QUEUE_EMAIL]
  },
  [EPM.ADMIN_CAMPAIGNS_BIDS]: {
    original: [EPA.LIST, EPA.UPDATE],
    modified: [EP.ADMIN_CAMPAIGNS_BIDS_LIST, EP.ADMIN_CAMPAIGNS_BIDS_UPDATE]
  },
  [EPM.ADMIN_CAMPAIGNS_PRICING]: {
    original: [EPA.GET, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_CAMPAIGNS_PRICING_GET, EP.ADMIN_CAMPAIGNS_PRICING_UPDATE, EP.ADMIN_CAMPAIGNS_PRICING_DELETE]
  },
  [EPM.ADMIN_CAMPAIGNS_LIMITS]: {
    original: [EPA.CREATE, EPA.LIST, EPA.DELETE],
    modified: [EP.ADMIN_CAMPAIGNS_LIMITS_CREATE, EP.ADMIN_CAMPAIGNS_LIMITS_LIST, EP.ADMIN_CAMPAIGNS_LIMITS_DELETE]
  },
  [EPM.ADMIN_CAMPAIGNS_AUDIENCE]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_CAMPAIGNS_AUDIENCE_GET, EP.ADMIN_CAMPAIGNS_AUDIENCE_UPDATE]
  },
  [EPM.ADMIN_UNAPPROVED_CREATIVES]: {
    original: [EPA.LIST, EPA.APPROVED, EPA.REJECT, EPA.TOTAL],
    modified: [EP.ADMIN_UNAPPROVED_CREATIVES_LIST, EP.ADMIN_UNAPPROVED_CREATIVES_APPROVED, EP.ADMIN_UNAPPROVED_CREATIVES_REJECT, EP.ADMIN_UNAPPROVED_CREATIVES_TOTAL]
  },
  [EPM.ADMIN_UNAPPROVED_USERS]: {
    original: [EPA.LIST, EPA.APPROVED, EPA.REJECT, EPA.TOTAL, EPA.SET_MANAGER],
    modified: [EP.ADMIN_UNAPPROVED_USERS_LIST, EP.ADMIN_UNAPPROVED_USERS_APPROVED, EP.ADMIN_UNAPPROVED_USERS_REJECT, EP.ADMIN_UNAPPROVED_USERS_TOTAL, EP.ADMIN_UNAPPROVED_USERS_SET_MANAGER]
  },

  [EPM.ADMIN_STATS]: {
    original: [EPA.BALANCE, EPA.REPORT],
    modified: [EP.ADMIN_STATS_BALANCE, EP.ADMIN_STATS_REPORT]
  },
  [EPM.ADMIN_OVERVIEW]: {
    original: [EPA.COUNTRIES],
    modified: [EP.ADMIN_OVERVIEW_COUNTRIES]
  },
  [EPM.ADMIN_TOPUPS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_TOPUPS_LIST, EP.ADMIN_TOPUPS_GET, EP.ADMIN_TOPUPS_CREATE, EP.ADMIN_TOPUPS_UPDATE, EP.ADMIN_TOPUPS_DELETE]
  },
  [EPM.ADMIN_RECOMMENDED_CPC]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_RECOMMENDED_CPC_LIST, EP.ADMIN_RECOMMENDED_CPC_GET, EP.ADMIN_RECOMMENDED_CPC_CREATE, EP.ADMIN_RECOMMENDED_CPC_UPDATE, EP.ADMIN_RECOMMENDED_CPC_DELETE]
  },
  [EPM.ADMIN_GROUPS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_GROUPS_LIST, EP.ADMIN_GROUPS_GET, EP.ADMIN_GROUPS_CREATE, EP.ADMIN_GROUPS_UPDATE, EP.ADMIN_GROUPS_DELETE]
  },
  [EPM.ADMIN_BIDS]: {
    original: [EPA.LIST, EPA.GET, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_BIDS_LIST, EP.ADMIN_BIDS_GET, EP.ADMIN_BIDS_CREATE, EP.ADMIN_BIDS_UPDATE, EP.ADMIN_BIDS_DELETE]
  },
  [EPM.ADMIN_DASHBOARD]: {
    original: [EPA.CHART, EPA.SUM],
    modified: [EP.ADMIN_DASHBOARD_CHART, EP.ADMIN_DASHBOARD_SUM]
  },
  [EPM.ADMIN_LOGIN_HISTORY]: {
    original: [EPA.LIST],
    modified: [EP.ADMIN_LOGIN_HISTORY_LIST]
  },
  [EPM.ADMIN_PROFILE]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.ADMIN_PROFILE_GET, EP.ADMIN_PROFILE_UPDATE]
  },
  [EPM.SETTINGS]: {
    original: [EPA.GET, EPA.UPDATE],
    modified: [EP.SETTINGS_GET, EP.SETTINGS_UPDATE]
  },
  [EPM.ADMIN_CHANGELOG]: {
    original: [EPA.LIST, EPA.CREATE, EPA.UPDATE, EPA.DELETE],
    modified: [EP.ADMIN_CHANGELOG_LIST, EP.ADMIN_CHANGELOG_CREATE, EP.ADMIN_CHANGELOG_UPDATE, EP.ADMIN_CHANGELOG_DELETE]
  },
}
const CPT = constructedPermissionTree

export const adminModules = [
  EPM.ADMIN_USERS,
  EPM.ADMIN_PERMISSIONS,
  EPM.ADMIN_CAMPAIGNS,
  EPM.ADMIN_TOPUPS,
  EPM.ADMIN_LOGIN_HISTORY,
  EPM.ADMIN_FAST_LOGIN,
  EPM.ADMIN_PROFILE,
  EPM.ADMIN_CAMPAIGNS_CREATIVES,
  EPM.ADMIN_CAMPAIGNS_AUDIENCE,
  EPM.ADMIN_CAMPAIGNS_LIMITS,
  EPM.ADMIN_CAMPAIGNS_PRICING,
  EPM.ADMIN_CAMPAIGNS_GROUPS,
  EPM.ADMIN_CAMPAIGNS_BIDS,
  EPM.ADMIN_UNAPPROVED_CREATIVES,
  EPM.ADMIN_UNAPPROVED_USERS,
  EPM.ADMIN_OVERVIEW,
  EPM.ADMIN_DASHBOARD,
  EPM.ADMIN_GROUPS,
  EPM.ADMIN_STATS,
  EPM.ADMIN_COUNTRY,
  EPM.ADMIN_BIDS,
  EPM.ADMIN_RECOMMENDED_CPC,
  EPM.ADMIN_USERS_BALANCE,
  EPM.ADMIN_LOGS,
  EPM.ADMIN_CHANGELOG
]


export const affiliateModules = [
  EPM.AFFILIATE_DOMAINS,
  EPM.AFFILIATE_LOGIN_HISTORY,
  EPM.AFFILIATE_PROFILE,
  EPM.AFFILIATE_PAYMENTS,
  EPM.AFFILIATE_BALANCE,
  EPM.AFILIATE_REFERRAL,
]

export const advertiserModules = [

]

export const adminActions = [
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_PERMISSIONS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS].modified,
  ...CPT[EPM.ADMIN_TOPUPS].modified,
  ...CPT[EPM.ADMIN_FAST_LOGIN].modified,
  ...CPT[EPM.ADMIN_LOGIN_HISTORY].modified,
  ...CPT[EPM.ADMIN_PROFILE].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_CREATIVES].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_AUDIENCE].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_LIMITS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_PRICING].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_GROUPS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_BIDS].modified,
  ...CPT[EPM.ADMIN_UNAPPROVED_CREATIVES].modified,
  ...CPT[EPM.ADMIN_UNAPPROVED_USERS].modified,
  ...CPT[EPM.ADMIN_DASHBOARD].modified,
  ...CPT[EPM.ADMIN_GROUPS].modified,
  ...CPT[EPM.ADMIN_STATS].modified,
  ...CPT[EPM.ADMIN_COUNTRY].modified,
  ...CPT[EPM.ADMIN_BIDS].modified,
  ...CPT[EPM.ADMIN_USERS_BALANCE].modified,
  ...CPT[EPM.ADMIN_RECOMMENDED_CPC].modified,
  ...CPT[EPM.ADMIN_LOGS].modified,
  ...CPT[EPM.ADMIN_OVERVIEW].modified,
  ...CPT[EPM.ADMIN_CHANGELOG].modified,
]

export const managerActions = [
  ...CPT[EPM.ADMIN_USERS].modified,
  ...CPT[EPM.ADMIN_PERMISSIONS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS].modified,
  ...CPT[EPM.ADMIN_FAST_LOGIN].modified,
  ...CPT[EPM.ADMIN_TOPUPS].modified,
  ...CPT[EPM.ADMIN_LOGIN_HISTORY].modified,
  ...CPT[EPM.ADMIN_PROFILE].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_CREATIVES].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_AUDIENCE].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_LIMITS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_PRICING].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_GROUPS].modified,
  ...CPT[EPM.ADMIN_CAMPAIGNS_BIDS].modified,
  ...CPT[EPM.ADMIN_UNAPPROVED_CREATIVES].modified,
  ...CPT[EPM.ADMIN_UNAPPROVED_USERS].modified,
  ...CPT[EPM.ADMIN_DASHBOARD].modified,
  ...CPT[EPM.ADMIN_GROUPS].modified,
  ...CPT[EPM.ADMIN_STATS].modified,
  ...CPT[EPM.ADMIN_COUNTRY].modified,
  ...CPT[EPM.ADMIN_BIDS].modified,
  ...CPT[EPM.ADMIN_USERS_BALANCE].modified,
  ...CPT[EPM.ADMIN_RECOMMENDED_CPC].modified,
  ...CPT[EPM.ADMIN_LOGS].modified,
  ...CPT[EPM.ADMIN_OVERVIEW].modified,
  ...CPT[EPM.ADMIN_CHANGELOG].modified,
]

export const affiliateActions = []

export const commonModules = []
export const commonActions = []